import './view/sw-customer-detail-contacts/sw-customer-detail-contacts';

Shopware.Module.register('sw-customer', {
    routeMiddleware(next, currentRoute) {
        if (currentRoute.name === 'sw.customer.detail.base') {
            currentRoute.children.push({
                name: 'sw.customer.detail.contacts',
                path: '/contacts',
                component: 'sw-customer-detail-contacts',
                meta: {
                    parentPath: 'sw.customer.detail',
                },
            });
        }
        next(currentRoute);
    },
});
